import _ from '@luna/lodash';

type FlatEnvironmentMap = Record<string, string>;

type GroupedEnvironmentMap = [string, string][][];

const PREFERRED_GROUP_SIZE = 3;
const FALLBACK_GROUP_SIZE = 2;

export function groupEnvironments(environmentMap: FlatEnvironmentMap): GroupedEnvironmentMap {
    const availableEnvironments = Object.entries(environmentMap);

    if (!availableEnvironments.length) {
        return [];
    }

    const ungroupedLeadingEnvironments = availableEnvironments.splice(
        0,
        availableEnvironments.length % PREFERRED_GROUP_SIZE,
    );

    const groupedEnvironments = _.chunk(availableEnvironments, PREFERRED_GROUP_SIZE);

    if (!groupedEnvironments.length) {
        return [ungroupedLeadingEnvironments];
    }

    if (ungroupedLeadingEnvironments.length === FALLBACK_GROUP_SIZE) {
        return [ungroupedLeadingEnvironments, ...groupedEnvironments];
    }

    if (ungroupedLeadingEnvironments.length === 1) {
        const [
            [firstGroupedEnvironment, ...otherFirstGroupEnvironments],
            ...otherEnvironmentGroups
        ] = groupedEnvironments;

        return [
            [...ungroupedLeadingEnvironments, firstGroupedEnvironment],
            [...otherFirstGroupEnvironments],
            ...otherEnvironmentGroups,
        ];
    }

    return groupedEnvironments;
}
